import { Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import React from 'react'

import { getDefaultCurrency } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { Multiplier } from '../../types/bulkUpdate'
import { CancelPolicy, ModifyPolicy } from '../../types/cancelAndModifyPolicies'
import InventoryInputItem from './InventoryInputItem'
import useStyles from './styles/InventoryNonRestrictionItems.style'

interface InventoryNonRestrictionItemsProps {
  availability: string
  setavailability: React.Dispatch<React.SetStateAction<string>>
  rateMultipliers: Multiplier[]
  setRateMultipliers: React.Dispatch<React.SetStateAction<Multiplier[]>>
  isChannelSelected?: string
  setCancelPolicyValue: React.Dispatch<any>
  cancelPolicyValue: { label: string; value: string } | null
  setModifyPolicyValue: React.Dispatch<any>
  modifyPolicyValue: { label: string; value: string } | null

  cancelPolicyData:
    | {
        cancelPolicies: CancelPolicy[]
      }
    | undefined

  modifyPolicyData:
    | {
        modifyPolicies: ModifyPolicy[]
      }
    | undefined

  loadingForCancelPolicy: boolean
  loadingForModifyPolicy: boolean
  isRoleAccommodation: boolean
}

const InventoryNonRestrictionItems: React.FC<
  InventoryNonRestrictionItemsProps
> = ({
  availability,
  setavailability,
  rateMultipliers,
  setRateMultipliers,
  isChannelSelected,
  cancelPolicyValue,
  setCancelPolicyValue,
  modifyPolicyValue,
  setModifyPolicyValue,
  cancelPolicyData,
  modifyPolicyData,
  loadingForCancelPolicy,
  loadingForModifyPolicy,
  isRoleAccommodation
}) => {
  const classes = useStyles()

  const OnAddMoreClick = () => {
    setRateMultipliers([
      ...rateMultipliers,
      {
        rateMultiplier: '',
        inputCurrency: getDefaultCurrency(),
        outputCurrency: getDefaultCurrency()
      }
    ])
  }

  return (
    <>
      <InventoryInputItem
        label={getTranslate('Availability')}
        value={availability}
        onChange={setavailability}
      />
      {isChannelSelected === 'CRS' && !isRoleAccommodation ? (
        <>
          <InventoryInputItem
            isChannelSelected={isChannelSelected}
            value={cancelPolicyValue?.value}
            label={getTranslate('Cancel Policy')}
            cancelPolicyValue={cancelPolicyValue}
            setCancelPolicyValue={setCancelPolicyValue}
            cancelPolicyData={cancelPolicyData}
            loadingForCancelPolicy={loadingForCancelPolicy}
          />
          <InventoryInputItem
            isChannelSelected={isChannelSelected}
            value={modifyPolicyValue?.value}
            label={getTranslate('Modify Policy')}
            modifyPolicyValue={modifyPolicyValue}
            setModifyPolicyValue={setModifyPolicyValue}
            modifyPolicyData={modifyPolicyData}
            loadingForModifyPolicy={loadingForModifyPolicy}
          />
        </>
      ) : (
        <>
          <div />
          <div />
        </>
      )}
      {isChannelSelected === 'Channel' && (
        <>
          {rateMultipliers.map((_, index) => (
            <React.Fragment key={index}>
              <InventoryInputItem
                label={getTranslate('Rate Multiplier')}
                multiplierIndex={index}
                rateMultipliers={rateMultipliers}
                setRateMultipliers={setRateMultipliers}
              />
              <InventoryInputItem
                label={getTranslate('Input Currency')}
                multiplierIndex={index}
                rateMultipliers={rateMultipliers}
                setRateMultipliers={setRateMultipliers}
                forCurrency
              />
              <InventoryInputItem
                label={getTranslate('Output Currency')}
                multiplierIndex={index}
                rateMultipliers={rateMultipliers}
                setRateMultipliers={setRateMultipliers}
                forCurrency
                outputCurrency
              />
            </React.Fragment>
          ))}
          <div className={classes.addSection} onClick={OnAddMoreClick}>
            <AddIcon className={classes.redColor} />
            <Typography className={classes.redColor}>
              {getTranslate('Add More Rate Multiplier')}
            </Typography>
          </div>
        </>
      )}
    </>
  )
}

export default InventoryNonRestrictionItems
